var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDotsVertical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0002 13.4598C12.7402 13.4598 13.3402 12.8598 13.3402 12.1198C13.3402 11.3797 12.7402 10.7798 12.0002 10.7798C11.2601 10.7798 10.6602 11.3797 10.6602 12.1198C10.6602 12.8598 11.2601 13.4598 12.0002 13.4598Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0002 8.43976C12.7402 8.43976 13.3402 7.83983 13.3402 7.09977C13.3402 6.3597 12.7402 5.75977 12.0002 5.75977C11.2601 5.75977 10.6602 6.3597 10.6602 7.09977C10.6602 7.83983 11.2601 8.43976 12.0002 8.43976Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0002 18.4696C12.7402 18.4696 13.3402 17.8696 13.3402 17.1295C13.3402 16.3895 12.7402 15.7896 12.0002 15.7896C11.2601 15.7896 10.6602 16.3895 10.6602 17.1295C10.6602 17.8696 11.2601 18.4696 12.0002 18.4696Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotsVertical);
export default __webpack_public_path__ + "static/media/dots-vertical.7ea1e016459cc7df59e3474cb486835c.svg";
export { ForwardRef as ReactComponent };